import {fabric} from "fabric";
import {getLockValue, removeObjectFromCanvas} from "@frontend/utils";
import {SAFE_ZONE_PREFIX_ID} from "@frontend/constants/templates-field-prefixes";
import {FIELD_TYPE_SAFE_ZONE} from "@frontend/constants/type-fields-of-template";
import {ShowPageScopeCollector} from "@frontend/group/modules/scope-collectors/show-page-collector";
import {scaleControlsCornerSize} from "@frontend/constants/fabric-constants";

const parseIntWithFallback = (value, fallback) => {
  const parsed = parseInt(value);
  return isNaN(parsed) ? fallback : parsed;
};

const parseFloatWithFallback = (value, fallback) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? fallback : parsed;
};

export const SAFE_ZONE_DEFAULT_VALUES = {
  OPACITY: 0.2,
  FILL_COLOR: '#000000',
  STROKE_COLOR: '#000000',
  STROKE_WIDTH: 0,
  ORDER: 99999,
}

const getScopePage = () => ShowPageScopeCollector.get(['canvas_data']);

export const drawSafeZone = ({
  canvas,
  data,
  fields,
  id,
}) => {
  const { canvas_data } = getScopePage();

  removeObjectFromCanvas(canvas, SAFE_ZONE_PREFIX_ID)

  canvas_data[id].safeZone.forEach((elementId, index) => {
    const field = fields.find(field => field.element_id === elementId);

    if (!field) {
      return;
    }

    const options = JSON.parse(field.options);

    const x = parseIntWithFallback(data[`${elementId}_offset_x`], parseInt(options.X));
    const y = parseIntWithFallback(data[`${elementId}_offset_y`], parseInt(options.Y));
    let width = parseIntWithFallback(data[`${elementId}_width`], parseInt(options.Width));
    let height = parseIntWithFallback(data[`${elementId}_height`], parseInt(options.Height));
    const opacity = parseFloatWithFallback(data[`${elementId}_opacity`], options.Option4) || SAFE_ZONE_DEFAULT_VALUES.OPACITY;
    const fillColor = data[`${elementId}_fill_color`] || options.Option3 || SAFE_ZONE_DEFAULT_VALUES.FILL_COLOR;
    const strokeWidth = parseIntWithFallback(data[`${elementId}_thickness`], parseInt(options.Option2)) || SAFE_ZONE_DEFAULT_VALUES.STROKE_WIDTH;
    const strokeColor = data[`${elementId}_stroke_color`] || options.Option1 || SAFE_ZONE_DEFAULT_VALUES.STROKE_COLOR;
    const visible = data[`${elementId}_visible`] ?? !options.Hidden;

    if (strokeWidth && !isNaN(+strokeWidth)) {
      width -= +strokeWidth
      height -= +strokeWidth
    }

    const safeZone = new fabric.CustomRect({
      id: SAFE_ZONE_PREFIX_ID + index,
      element_id: elementId,
      order: SAFE_ZONE_DEFAULT_VALUES.ORDER,
      top: y,
      left: x,
      width: width,
      height: height,
      opacity: opacity,
      fieldId: field.id,
      fieldType: FIELD_TYPE_SAFE_ZONE,
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth,
      locked: getLockValue(id, elementId),
      templateField: canvas_data[id].templateInstance.getFieldById(field.id),
      selectable: true,
      evented: true,
      selectableBordersOnly: true,
      strokeUniform: true,
      visible: visible
    });

    scaleControlsCornerSize(safeZone);

    canvas.add(safeZone);
  });
}
